import { useEffect } from 'react';

import WebApp from '@twa-dev/sdk';

import { getOrientation } from '@/shared/helpers/environment/get-orientation';
import { Orientation } from '@/shared/store/app-store/types';

export const useLockOrientation = () => {
  useEffect(() => {
    const updateOrientation = () => {
      const orientation = getOrientation();

      if (orientation === Orientation.PORTRAIT) {
        // If the orientation changes to the portrait orientation, then after the lock
        WebApp.lockOrientation?.();
        window.removeEventListener('resize', updateOrientation);
      }
    };

    if (!WebApp.isOrientationLocked) {
      // If earlier in the index.html the orientation has not been blocked, then we are monitoring the orientation change
      window.addEventListener('resize', updateOrientation);
    }

    return () => window.removeEventListener('resize', updateOrientation);
  }, []);
};
